import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import { Dashboard } from 'components/Layout';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { UserType } from 'store/modules/auth/auth';
import User from 'components/User/User';
import api from 'api';
import AdminMenu from 'components/AdminMenu/AdminMenu';

const { ROUTES, Redirect } = RouterProvider;
const { connect, selectors, actions } = StoreProvider;

interface OrganizationProjectProps extends Omit<RouteComponentProps, 'match'> {
  user: UserType;
  match: {
    params: {
      codename: string;
      uuid: string;
    };
  };
  setOrganizationsUser: (user: UserType) => void;
}

const OrganizationUser = ({
  user,
  setOrganizationsUser,
  match: { params },
  location,
  history,
}: OrganizationProjectProps) => {
  const refreshUser = () =>
    api.resources
      .getOrganizationUser({
        uuid: params.uuid,
        organization_name: params.codename,
      })
      .then(({ data }) => {
        setOrganizationsUser(data);
      })
      .catch(() => {
        history.push(`/admin/organizations/${params.codename}/users`);
      });

  useEffect(() => {
    if (params.uuid) {
      refreshUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (!params.codename || !params.uuid) {
    return <Redirect to={ROUTES.ADMIN.ORGANIZATIONS.LIST} />;
  }

  return (
    <Dashboard title={`Organization ${params.codename}`} location={location}>
      <Grid item xs={12}>
        <AdminMenu />
      </Grid>
      <User {...user} />
    </Dashboard>
  );
};

export default connect(
  (state, ownProps: OrganizationProjectProps) => ({
    user: selectors.organizationsSelectors.userByUuid(
      ownProps.match.params.uuid
    )(state),
  }),
  {
    setOrganizationsUser: actions.organizationsActions.setOrganizationsUser,
  }
)(OrganizationUser);
